import { useMutation } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import api from '@/constant/END_POINT'

const createClaimReject = async (claimFormId: string, claimRejectDetail: string) => {
  const response = await httpClientPrivate.post(api.backoffice.reject(claimFormId), {
    claimRejectDetail,
  })

  return response.data
}

const useCreateClaimReject = () => {
  const mutation = useMutation({
    mutationKey: ['useCreateClaimReject'],
    mutationFn: async ({
      claimFormId,
      claimRejectDetail,
    }: {
      claimFormId: string
      claimRejectDetail: string
    }) => createClaimReject(claimFormId, claimRejectDetail),
  })

  return mutation
}

export { useCreateClaimReject }
